var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"layer1","d":"M23,41,45,61.293,67,41","transform":"translate(-22.322 -40.265)","fill":"none","stroke":"#fff","strokeMiterlimit":"10","strokeWidth":"2"}));
}

ChevronDown.defaultProps = {"width":"45.356","height":"22.389","viewBox":"0 0 45.356 22.389"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
